import { useMemo } from 'react';
import { useParams, usePathname } from 'next/navigation';

function useNullableParams(): ReturnType<typeof useParams> | null | undefined {
  return useParams();
}

export function useRoutePattern(): string {
  const params = useNullableParams();
  const pathname = usePathname();

  return useMemo(() => {
    if (params === null || params === undefined) {
      return pathname || '/';
    }

    const reverseMap = new Map<string, string | string[]>();
    for (const key of Object.keys(params)) {
      const paramValue = params[key];
      if (paramValue !== undefined) {
        reverseMap.set(Array.isArray(paramValue) ? paramValue.join('/') : paramValue, key);
      }
    }

    const segments = pathname.split('/').filter(Boolean);
    let reconstructedPath = '';

    for (const segment of segments) {
      const paramKey = reverseMap.get(segment);
      if (paramKey) {
        const keyString = Array.isArray(paramKey) ? paramKey.join(',') : paramKey;
        reconstructedPath += `/[${keyString}]`;
      } else {
        reconstructedPath += `/${segment}`;
      }
    }

    for (const [paramKey, paramValue] of Object.entries(params)) {
      if (Array.isArray(paramValue)) {
        const joined = paramValue.join('/');
        if (pathname.includes(joined)) {
          reconstructedPath = reconstructedPath.replace(`/${joined}`, `/[[...${paramKey}]]`);
        }
      }
    }

    return reconstructedPath || '/';
  }, [params, pathname]);
}
